(function () {
  function setup(nav) {
    if (!nav || nav.dataset.stickyNavInit === 'true') return;
    nav.dataset.stickyNavInit = 'true';

    var addSpacing = nav.getAttribute('data-add-content-spacing') === 'true';
    var breakpoint = parseInt(nav.getAttribute('data-mobile-breakpoint'), 10) || 749;

    function isVisible() {
      // The bar is CSS-hidden (display:none) above the breakpoint; only
      // reserve page space while it's actually shown.
      return window.getComputedStyle(nav).display !== 'none';
    }

    function applySpacing() {
      if (!addSpacing) return;

      if (isVisible()) {
        var height = nav.offsetHeight;
        document.documentElement.style.setProperty('--sticky-bottom-nav-space', height + 'px');
        document.body.classList.add('has-sticky-bottom-nav-spacing');
      } else {
        document.body.classList.remove('has-sticky-bottom-nav-spacing');
        document.documentElement.style.setProperty('--sticky-bottom-nav-space', '0px');
      }
    }

    applySpacing();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(applySpacing, 150);
    });
  }

  function initAll(scope) {
    var navs = (scope || document).querySelectorAll('[data-sticky-bottom-nav]');
    navs.forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var nav = event.target.querySelector('[data-sticky-bottom-nav]');
    if (nav) nav.dataset.stickyNavInit = '';
    initAll(event.target);
  });
})();